<template>
  <div class="moow-master-container">
    <div v-if="loading || !listing" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <div class="container mt-3 mb-5" v-if="listing">
      <b-row>
        <b-col>
          <md-tabs
            :md-active-tab="activeTab"
            class="play-tabs white"
            @md-changed="changedTab"
            md-elevation="2"
          >
            <md-tab id="deals-tab" md-label="Deals">
              <md-progress-bar md-mode="indeterminate" v-if="loadingDeals"></md-progress-bar>
              <md-empty-state
                v-else-if="!deals || deals.length == 0"
                md-icon="gavel"
                md-label="This property bookings, contracts and other Deals are here."
                md-description="You can create a deal manually (import) or they will be created automatically, when tenant is interested in Your listing."
              >
                <md-button
                  class="md-raised md-primary play-cta-button makeup"
                  @click="startNewDeal()"
                >New Deal</md-button>
              </md-empty-state>
              <deal-descriptors v-else :deals="deals" @emitStartNewDeal="startNewDeal" />
            </md-tab>
            <!-- ### REPRESENTATIVES ###-->
            <md-tab id="contract-tab" md-label="Legal">
              <property-rep-selector
                :propertyId="listing._id"
                @setLegalStructure="setLegalStructure"
              />
            </md-tab>
            <md-tab id="notes-tab" md-label="Notes">
              <p class="moow-subheader">Keep track of property notes</p>

              <!-- ### NOTES ###-->
              <listing-notes :listingId="listing.maaklerID"></listing-notes>
            </md-tab>

            <md-tab id="guider-tab" md-label="Tenant guides">
              <p class="moow-subheader">These will be sent to tenant via Chat and Email</p>
              <md-progress-bar md-mode="indeterminate" v-if="loadingPropertyGuides"></md-progress-bar>
              <div v-else>
                <hr />
                <p class="input-header">When you accept booking application</p>
                <md-field>
                  <label>Welcome message to Tenant</label>
                  <md-textarea
                    v-model="tenantWelcomeMessage"
                    md-autogrow
                    :placeholder="tenantGuidePlaceholder"
                  ></md-textarea>
                  {{guideSaveStatus}}
                </md-field>

                <p class="input-header">Move in day</p>
                <md-field>
                  <label>When tenant moves in</label>
                  <md-textarea
                    v-model="tenantMoveInMessage"
                    md-autogrow
                    placeholder="Today is the day! You can find access codes to your apartment in the chat and on Your email...."
                  ></md-textarea>
                  {{guideSaveStatus}}
                </md-field>
              </div>
            </md-tab>

            <!-- ### FILES ###-->
            <md-tab id="documents-tab" md-label="Files">
              <p class="moow-subheader">Keep track of property files</p>

              <md-progress-spinner
                v-if="uploadingFiles"
                :md-diameter="30"
                :md-stroke="3"
                md-mode="indeterminate"
              ></md-progress-spinner>
              <md-button
                v-else
                class="md-primary play-cta-button-flat mb-3"
                @click="showFileUploader=true"
                :disabled="uploadingFiles"
              >Upload files</md-button>

              <div
                v-if="noFiles"
                class="no-content-holder"
                :style="{ 'background': 'url(' + noContentIcon + ') no-repeat center center /contain'}"
              ></div>
              <div v-else class="files-container play-shadow">
                <div class="files-scroll-container">
                  <div v-for="(filename,index) in listingFileNames" :key="filename+index">
                    <md-chip
                      class="md-primary mt-3 play-chip light"
                      @click="fileAction(filename)"
                      md-clickable
                    >
                      <md-icon>{{getFileIconGate(filename)}}</md-icon>
                      {{filename}}
                    </md-chip>
                  </div>
                  <div class="scroll-opaq-compensator" />
                </div>
              </div>
            </md-tab>

            <!-- ### ANALYTICS ###-->
            <md-tab id="analytics-tab" md-label="Analytics">
              <md-card class="island-card">
                <md-table v-model="listingVisits" v-if="listingVisits">
                  <md-table-toolbar>
                    <div>
                      <h1 class="md-title">Latest Views</h1>
                      <p class="moow-info-txt secondary">Statistics on Moowle marketplace</p>
                    </div>
                  </md-table-toolbar>

                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="Viewed on">{{ stats_getViewedOn(item) }}</md-table-cell>
                    <md-table-cell md-label="Coming From">{{ stats_getComingFrom(item) }}</md-table-cell>
                    <md-table-cell md-label="Device">{{ stats_getDevice(item) }}</md-table-cell>
                  </md-table-row>
                </md-table>
                <md-progress-bar v-else md-mode="indeterminate"></md-progress-bar>
              </md-card>

              <md-table md-card>
                <md-table-toolbar>
                  <h1 class="md-title">Views Globally</h1>
                </md-table-toolbar>
                <md-table-row>
                  <md-table-head>Portal</md-table-head>
                  <md-table-head>Total Views</md-table-head>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Moowle.com</md-table-cell>
                  <md-table-cell v-if="loadingAnalyticsViews" class="analytics-view-loader-mini">
                    <img :src="loaderIcon" />
                  </md-table-cell>
                  <md-table-cell v-else>{{this.listingViewsMoowle}}</md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>City24.ee</md-table-cell>
                  <md-table-cell v-if="loadingAnalyticsViews" class="analytics-view-loader-mini">
                    <img :src="loaderIcon" />
                  </md-table-cell>
                  <md-table-cell v-else>{{this.listingViewsCity}}</md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Kinnisvara24.ee</md-table-cell>
                  <md-table-cell v-if="loadingAnalyticsViews" class="analytics-view-loader-mini">
                    <img :src="loaderIcon" />
                  </md-table-cell>
                  <md-table-cell v-else>{{this.listingViewsKv24}}</md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Kv.ee</md-table-cell>
                  <md-table-cell v-if="loadingAnalyticsViews" class="analytics-view-loader-mini">
                    <img :src="loaderIcon" />
                  </md-table-cell>
                  <md-table-cell v-else>{{this.listingViewsKv}}</md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Reales.ee</md-table-cell>
                  <md-table-cell v-if="loadingAnalyticsViews" class="analytics-view-loader-mini">
                    <img :src="loaderIcon" />
                  </md-table-cell>
                  <md-table-cell v-else>{{this.listingViewsReales}}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-tab>

            <!-- ### DISTRIBUTION ###-->
            <md-tab id="dist-tab" md-label="Distribution">
              <md-card class="island-card">
                <md-card-content>
                  <p class="moow-info-txt">Choose the channels the listing is sent to.</p>
                  <p
                    class="moow-info-txt secondary"
                  >Selected channels will start automatically displaying your listing after ~6hours, no additional setup needed from you.</p>
                  <hr class="hr-form-el-separator" />
                  <b-col
                    md="12"
                    v-for="channel in distrChannels"
                    :key="channel.value"
                    class="dist-channels"
                  >
                    <md-checkbox
                      v-if="!channel.disabled"
                      class="md-primary"
                      v-model="channel.showInChannel"
                      :disabled="channel.disabled || !userRoleCanEditProperty"
                    >{{getPortalFullName(channel.value)}}</md-checkbox>
                    <!-- <b-form-checkbox v-model="channel.showInChannel">{{getPortalFullName(channel.value)}}</b-form-checkbox> -->
                  </b-col>
                </md-card-content>
                <md-card-actions>
                  <md-button
                    v-if="userRoleCanEditProperty"
                    class="md-primary play-cta-button makeup"
                    @click="updateDistribution()"
                  >Save</md-button>
                </md-card-actions>
              </md-card>
            </md-tab>

            <!-- ### ACCOUNTING ###-->
            <md-tab id="accounting-tab" md-label="Accounting">
              <md-card class="island-card">
                <md-card-content>
                  <p class="moow-info-txt">Set the accounting period for this property.</p>
                  <p
                    class="moow-info-txt secondary"
                  >This setting allows tenants payment schedule to follow your own accounting setup. If you dont't set the period, calendar month period (01 - 28/30/31) will be used.</p>
                  <hr class="hr-form-el-separator" />
                  <b-row>
                    <b-col cols="6" lg="3">
                      <md-field :class="{ 'md-invalid': accountingStartDayErr }">
                        <label>From (day of month)</label>
                        <md-input v-model="accountingStartDay" type="number"></md-input>
                        <span class="md-error">{{accountingStartDayErr}}</span>
                      </md-field>
                    </b-col>
                    <b-col cols="6" lg="3">
                      <md-field :class="{ 'md-invalid': accountingEndDayErr }">
                        <label>To (day of month)</label>
                        <md-input v-model="accountingEndDay" type="number"></md-input>
                        <span class="md-error">{{accountingEndDayErr}}</span>
                      </md-field>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>{{accountingSaveStatus}}</b-col>
                  </b-row>
                </md-card-content>
              </md-card>
            </md-tab>

            <!-- ### CONTRACT FEE ###-->
            <md-tab id="contract-fee-tab" md-label="Contract fee">
              <contract-fee-card
                :property-id="listing._id.toString()"
                :actual-booking-fee-value="actualBookingFeeValue"
                :actual-booking-fee-percentage="actualBookingFeePercentage"
                @changesSaved="handleFeesSavedEvent"
              ></contract-fee-card>
            </md-tab>
          </md-tabs>
        </b-col>
      </b-row>
    </div>

    <md-dialog :md-active.sync="showFileUploader" style="width:90vw;">
      <b-row style="padding:1em;">
        <b-col>
          <multi-file-uploader v-if="showFileUploader" @uploadedFileNames="addFiles"></multi-file-uploader>
        </b-col>
      </b-row>
    </md-dialog>

    <md-snackbar :md-duration="Infinity" md-persistent :md-active.sync="showDownloadSnackbar">
      <span>{{downloadSnackBarMessage}}</span>
      <md-progress-spinner
        v-if="downloadingFile"
        :md-diameter="30"
        :md-stroke="3"
        md-mode="indeterminate"
      ></md-progress-spinner>
      <div v-else>
        <md-button class="md-primary" @click="showDownloadSnackbar = false">Cancel</md-button>
        <md-button class="md-accent" @click="deleteFile()" v-if="userRoleCanEditProperty">Delete</md-button>
        <md-button class="md-raised md-primary" @click="downloadFile()">Download</md-button>
      </div>
    </md-snackbar>

    <md-snackbar md-persistent :md-active.sync="showSnackbar">
      <span>{{snackbarMessage}}</span>
    </md-snackbar>
  </div>
</template>
<script>
let loggedin;
let currentUserId;
import ListingNotes from "../components/listingNotes.vue";
import MultiFileUploader from "../components/files/multiFileUploader.vue";
import PropertyRepSelector from "../components/property/propertyRepSelector.vue";
import {
  downloadUserFile,
  getFileIcon,
} from "../platform/files/services/fileService";
import { setListingToBeReloadedUponDashboardVisit } from "../listingFunctions.js";
import {
  getListingViews,
  getListingVisits,
} from "../platform/analytics/repositories/analyticsRepository.js";
import { updateExcludedChannels } from "../channelRepository.js";
import { updateListingDetails } from "../listings/listingService.js";
import {
  upsertPropertyInStorage,
  upsertPropertyRepresentatives,
} from "../platform/properties/services/propertyService";
import {
  getPropertyGuides,
  upsertPropertyGuides,
  upsertPropertyAccountingPeriod,
} from "../platform/properties/repository/propertyRepository";
import { getPropertyDeals } from "../platform/deals/services/dealsService";
import DealDescriptors from "./deals/dealDescriptors.vue";
import moment from "moment";
import ContractFeeCard from './ContractFeeCard.vue';
var lodash = require("lodash/function");

export default {
  name: "listingManager",
  props: {
    listing: {
      type: Object,
      required: true,
    },
  },
  components: {
    "listing-notes": ListingNotes,
    "multi-file-uploader": MultiFileUploader,
    "property-rep-selector": PropertyRepSelector,
    "deal-descriptors": DealDescriptors,
    ContractFeeCard,
  },
  data() {
    return {
      deals: [],
      loadingDeals: true,
      showFileUploader: false,
      uploadingFiles: false,
      showSnackbar: false,
      downloadSnackBarMessage: "",
      showDownloadSnackbar: false,
      snackbarMessage: "",
      selectedRep: "",
      thirdPartyName: "",
      thirdPartyEmail: "",
      thirdPartyAdr: "",
      thirdPartyIdCode: "",
      loading: false,
      listingViewsCity: "no data",
      listingViewsKv: "no data",
      listingViewsMoowle: "no data",
      listingViewsKv24: "no data",
      listingViewsReales: "no data",
      activeTab: "deals-tab",
      coverImage: undefined,
      loadingAnalyticsViews: true,
      distrChannels: [],
      portalsAbbreviations: {
        city24: "City24.ee",
        kv: "kv.ee",
        kv24: "Kinnisvara24.ee",
        reales: "Reales.ee",
      },
      listingFileNames: [],
      selectedFileName: "",
      downloadingFile: false,
      tenantWelcomeMessage: "",
      loadingPropertyGuides: false,
      guideSaveStatus: "",
      tenantMoveInMessage: "",
      accountingEndDay: undefined,
      accountingStartDay: undefined,
      accountingSaveStatus: "",
      loadingPropertyAccounting: true,
      accountingStartDayErr: undefined,
      accountingEndDayErr: undefined,
    };
  },
  watch: {
    tenantWelcomeMessage: function (val) {
      this.guideSaveStatus = "";
      if (val) this.saveTenantGuide();
    },
    tenantMoveInMessage: function (val) {
      this.guideSaveStatus = "";
      if (val) this.saveTenantGuide();
    },
    accountingStartDay: function (val) {
      this.accountingSaveStatus = "";
      this.accountingStartDayErr = "";

      if (val > 31 || val < 0) {
        this.accountingStartDayErr = "Must be valid day";
        return;
      }else if (val) this.saveAccountingPeriod();
    },
    accountingEndDay: function (val) {
      this.accountingSaveStatus = "";
      this.accountingEndDayErr = "";
      if (val > 31 || val < 0) {
        this.accountingEndDayErr = "Must be valid day";
        return;
      }else if (val) this.saveAccountingPeriod();
    },
  },
  computed: {
    tenantGuidePlaceholder() {
      return (
        "Welcome to " +
        this.getDisplayAddress(this.listing) +
        ", we wish you a pleasant stay! Here is a list of important things to keep in mind..."
      );
    },
    currentUserRole() {
      return this.$store.getters.userRoleInAccount;
    },
    userRoleCanEditProperty() {
      if (!this.currentUserRole) return false;
      else if (
        this.$store.getters.accountWriteRoles.includes(this.currentUserRole)
      )
        return true;
      return false;
    },
    selectedFileNameShort() {
      let sub = this.selectedFileName.substring(0, 16);
      return sub + "...";
    },
    noContentIcon() {
      return require("../assets/404_listing.svg");
    },
    noFiles() {
      return this.listingFileNames.length <= 0;
    },
    currentUser() {
      return this.$store.getters.user;
    },
    listingImagePlaceholder() {
      return require("../assets/sanfran.svg");
    },
    loaderIcon() {
      return require("../assets/loader-rolling.svg");
    },
    loaderIconWhite() {
      return require("../assets/loader-rolling-white.svg");
    },
    listingVisits() {
      if (this.listing && this.listing.maaklerID)
        return this.$store.getters.listingVisits(this.listing.maaklerID);
    },
    selectedAccountId() {
      return this.$store.getters.selectedAccount;
    },
    actualBookingFeeValue() {
        const { fees: { bookingFeeValue } = {} } = this.listing;

        return bookingFeeValue;
    },
    actualBookingFeePercentage() {
        const { fees: { bookingFeePercentage } = {} } = this.listing;

        return bookingFeePercentage;
    },
  },
  created() {
    window.scrollTo(0, 0);
    if (!this.listing || !this.listing.maaklerID) this.redirectTo("dashboard");
    else {
  
      const title = this.getDisplayAddress(this.listing) + " | " + this.listing.marketingDet.shortDesc
      this.$emit("emitChangeViewTitle", title)
      this.coverImage = this.getCoverImage(this.listing.marketingDet.images);
      this.bindRepresenativeDetails(this.listing);
      this.setDistributionPortals(this.listing);
      this.setFileNames(this.listing);

      this.loadingDeals = true;
      getPropertyDeals({ propertyId: this.listing._id })
        .then((deals) => {
          this.deals = deals;
        })
        .catch((err) => {})
        .finally((f) => {
          this.loadingDeals = false;
        });
      this.getListingStatistics();
      this.getPropertyGuides();
      this.getPropertyAccountingPeriod();
    }
  },
  methods: {
    saveTenantGuide: lodash.debounce(async function (e) {
      this.guideSaveStatus = "Saving...";
      await upsertPropertyGuides(this.listing._id, {
        tenantWelcome: this.tenantWelcomeMessage,
        tenantMoveIn: this.tenantMoveInMessage,
      });
      this.guideSaveStatus = "Saved";
    }, 2000),
    saveAccountingPeriod: lodash.debounce(async function (e) {
      if (this.accountingStartDay && this.accountingEndDay && !this.accountingStartDayErr) {
        this.accountingSaveStatus = "Saving...";
        await upsertPropertyAccountingPeriod(this.listing._id, {
          startDay: this.accountingStartDay,
          endDay: this.accountingEndDay,
        });
        this.accountingSaveStatus = "Saved";
      }
    }, 1000),
    async getPropertyGuides() {
      this.loadingPropertyGuides = true;
      var guides = await getPropertyGuides(this.listing._id);
      this.tenantWelcomeMessage = guides.tenantWelcome;
      this.tenantMoveInMessage = guides.tenantMoveIn;
      this.loadingPropertyGuides = false;
    },
    async getPropertyAccountingPeriod() {
      this.loadingPropertyAccounting = true;
      const accountingPeriod = this.listing.accountingPeriod || {};
      this.accountingStartDay = accountingPeriod.startDay || '';
      this.accountingEndDay = accountingPeriod.endDay || '';
      this.loadingPropertyAccounting = false;
    },
    async getListingStatistics() {
      this.loadingAnalyticsViews = true;
      this.$store.dispatch("downloadListingVisits", {
        listingMID: this.listing.maaklerID,
      });

      var views = await getListingViews(
        this.listing.maaklerID,
        this.selectedAccountId
      );
      if (views && views.length > 0) {
        if (views.city24) this.listingViewsCity = views.city24;
        if (views.moowle) this.listingViewsMoowle = views.moowle;
        if (views.reales) this.listingViewsReales = views.reales;
        if (views.kinnisvara24) this.listingViewsKv24 = views.kinnisvara24;
        if (views.kv) this.listingViewsKv = views.kv;
        this.loadingAnalyticsViews = false;
      }
    },
    startNewDeal() {
      this.$store.commit("DA_SET_PROPERTY", this.listing);
      this.$store.commit("DA_RESET_LESSOR");
      this.redirectTo("dealApplicationLessor", {
        comingFromRouteName: "manage",
        property: this.listing,
      });
    },
    stats_getViewedOn(visit) {
      try {
        if (visit && visit.createdAt)
          return moment
            .unix(visit.createdAt._seconds)
            .format("DD.MM.YYYY, h:mm");
        // return moment.unix(1589355031).format('DD.MM.YYYY, h:mm')
      } catch (error) {}
      return "Unknown";
    },
    stats_getComingFrom(visit) {
      if (visit && visit.current) {
        if (visit.current.typ == "typein") return "Direct";
        // else if(visit.current.typ == "referral") return visit.current.src
        else return visit.current.src;
      } else return "Unknown";
    },
    stats_getDevice(visit) {
      if (visit && visit.udata && visit.udata.uag) {
        if (visit.udata.uag.toLowerCase().includes("Android"))
          return "Android Phone";
        else if (visit.udata.uag.toLowerCase().includes("ios"))
          return "Apple Phone";
        else return "PC";
      } else return "Unknown";
    },
    setLegalStructure(legalStructure) {
      upsertPropertyRepresentatives(legalStructure);
    },
    fileAction(filename) {
      this.selectedFileName = filename;
      this.downloadSnackBarMessage = this.selectedFileNameShort;
      this.showDownloadSnackbar = true;
    },
    deleteFile() {
      if (this.selectedFileName) {
        this.showDownloadSnackbar = true;
        this.downloadSnackBarMessage = "Deleting file...";

        // remove from UI bind
        this.listingFileNames = this.listingFileNames.filter(
          (e) => e !== this.selectedFileName
        );

        // remove from listing object
        if (
          this.listing.documentDet &&
          this.listing.documentDet.ownerFileNames
        ) {
          this.listing.documentDet.ownerFileNames = this.listing.documentDet.ownerFileNames.filter(
            (e) => e !== this.selectedFileName
          );
        }

        // update listing in server
        var listingUpdates = {
          ownerFileNames: this.listing.documentDet.ownerFileNames,
        };
        this.updateListing(listingUpdates);
        this.showDownloadSnackbar = false;
      }
    },
    downloadFile() {
      this.downloadSnackBarMessage = "Preparing to download";
      this.downloadingFile = true;
      downloadUserFile(this.selectedFileName)
        .catch((err) => {
          this.notifyUser(err);
        })
        .finally((f) => {
          this.downloadingFile = false;
          this.showDownloadSnackbar = false;
        });
    },
    addFiles(fileNames) {
      this.showFileUploader = false;
      this.uploadingFiles = true;

      var allFiles = [];
      if (this.listing.documentDet && this.listing.documentDet.ownerFileNames) {
        allFiles = this.listing.documentDet.ownerFileNames.concat(fileNames);
        this.listing.documentDet.ownerFileNames = allFiles;
      } else allFiles = fileNames;

      var listingUpdates = { ownerFileNames: allFiles };
      this.updateListing(listingUpdates);
    },
    updateListing(listingUpdates) {
      updateListingDetails(this.listing._id, "documentDet", listingUpdates)
        .then((updates) => {
          this.listingFileNames = updates.ownerFileNames;
          this.uploadingFiles = false;
          upsertPropertyInStorage(this.listing);
        })
        .catch((err) => {
          this.uploadingFiles = false;
        });
    },
    userHasCompanyDetails() {
      if (
        this.currentUser.companyDetails &&
        this.currentUser.companyDetails.name
      )
        return this.currentUser.companyDetails.name;
      else return false;
    },
    bindRepresenativeDetails(listing) {
      if (listing.contractDet) {
        this.selectedRep = listing.contractDet.contractRep;
        if (this.selectedRep == "thirdParty") {
          this.thirdPartyName = listing.contractDet.thirdPartyName;
          this.thirdPartyEmail = listing.contractDet.thirdPartyEmail;
          this.thirdPartyIdCode = listing.contractDet.thirdPartyIdCode;
          this.thirdPartyAdr = listing.contractDet.thirdPartyAdr;
        }
      }
    },
    getFileIconGate(filename) {
      return getFileIcon(filename);
    },
    getPortalFullName(abbreviation) {
      return this.portalsAbbreviations[abbreviation];
    },
    setFileNames(listing) {
      listing.documentDet
        ? (this.listingFileNames = listing.documentDet.ownerFileNames)
        : void 0;
    },
    setDistributionPortals(listing) {
      //TODO: dashboardlistings should get also excludedChannels <- server change
      var shownInKv = this.isPresentInArray(
        listing.availDet.excludedChannels,
        "kv"
      )
        ? false
        : true;
      var shownInKv24 = this.isPresentInArray(
        listing.availDet.excludedChannels,
        "kv24"
      )
        ? false
        : true;
      var shownInReales = this.isPresentInArray(
        listing.availDet.excludedChannels,
        "reales"
      )
        ? false
        : true;
      var shownInCity = this.isPresentInArray(
        listing.availDet.excludedChannels,
        "city24"
      )
        ? false
        : true;

      this.distrChannels.push({
        value: "city24",
        showInChannel: shownInCity,
        disabled: false,
      });
      this.distrChannels.push({
        value: "kv",
        showInChannel: false,
        disabled: true,
      });
      this.distrChannels.push({
        value: "kv24",
        showInChannel: shownInKv24,
        disabled: false,
      });
      this.distrChannels.push({
        value: "reales",
        showInChannel: shownInReales,
        disabled: false,
      });
    },
    getCoverImage(images) {
      if (images) {
        let idx = images.findIndex((file) => {
          return file.cover == true;
        });
        if (idx > -1) return images[idx].url;
      }
      return this.listingImagePlaceholder;
    },
    exitToDashboard() {
      this.$router.push({
        name: "dashboard",
      });
    },
    getDisplayAddress(data) {
      if (!data) return;
      if (
        data.location.address.apartNumber &&
        data.location.address.municipality
      )
        return (
          data.location.address.municipality +
          ", " +
          data.location.address.street +
          " " +
          data.location.address.number +
          " - " +
          data.location.address.apartNumber
        );
      else if (data.location.address.municipality)
        return (
          data.location.address.municipality +
          ", " +
          data.location.address.street +
          " " +
          data.location.address.number
        );
      else
        return (
          data.location.address.street + " " + data.location.address.number
        );
    },
    isPresentInArray(ar, findMe) {
      if (!ar || ar.length == 0) return false;
      for (var i = 0; i < ar.length; i++) {
        if (ar[i] == findMe) return true;
      }
      return false;
    },
    updateDistribution() {
      var exludedChannels = [];
      for (var i = 0; i < this.distrChannels.length; i++) {
        if (!this.distrChannels[i].showInChannel)
          exludedChannels.push(this.distrChannels[i].value);
      }
      this.notifyUser("Property updated");
      this.listing.availDet.excludedChannels = exludedChannels;
      upsertPropertyInStorage(this.listing);
      updateExcludedChannels(this.listing.maaklerID, exludedChannels)
        .then((res) => {})
        .catch((err) => {
          this.notifyUser("Cannot update, try again later!");
        });
    },
    changedTab(tabId) {
      this.activeTab = tabId;
    },
    notifyUser(msg) {
      this.snackbarMessage = msg;
      this.showSnackbar = true;
    },
    redirectTo(name, params) {
      this.$router.push({
        name: name,
        params: params,
      });
    },
    handleFeesSavedEvent(fees) {
        upsertPropertyInStorage(Object.assign({}, this.listing, { fees }));
        this.notifyUser('Booking fee values have been updated');
    },
  },
};
</script>
<style scoped>
@import "../assets/styles/listing-manager.css";
@import "../assets/styles/global.css";

.scroll-opaq-compensator {
  height: 30px;
  widows: 100%;
}

.files-scroll-container {
  height: 100%;
  margin: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}

.files-scroll-container::-webkit-scrollbar {
  width: 0px;
}

.files-container {
  position: relative;
  height: 400px;
  padding: 1em;
  background-color: white;
  overflow: hidden;
  border-radius: 10px;
}

.files-container:after {
  content: "";
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  pointer-events: none;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1) 90%
  );
  width: 100%;
  height: 5em;
}

.listing-hero-container {
  height: 20vh;
  position: relative;
}

.listing-hero-overscreen {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  background-color: #020202ad;
  color: white;
  text-align: center;
  padding-top: 4em;
}

.listing-hero-holder {
  position: absolute;
  height: 100%;
  width: 100%;
}

.analytics-view-loader-mini img {
  height: 38px;
  width: 38px;
}

.no-content-holder {
  height: 100px;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/ListingManager.vue